'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _links = require('../utils/links');

var EXTERNAL_LINKS = [_links.codeFunnelAnatomy.name, _links.codeFunnelData.name, _links.codeFunnelExcel.name, _links.codeFunnelSeo.name, _links.codeFunnelInfographics.name, _links.codeFunnelTemplates.name];

exports.default = function (intent) {
  return EXTERNAL_LINKS.indexOf(intent) !== -1;
};

module.exports = exports['default'];